axios.defaults.baseURL = '/api/insightGrid';
var Api = {
  solar: {
    GetSinglePlantSum: '/solar/singlePlantSum',
    GetWholePlantSum: '/solar/wholePlantSum',
    GetTopInformation: '/solar/topInformation',
    GetAnalysisCharts: '/solar/analysisCharts'
  },
  bms: {
    GetSinglePlantSum: '/bms/singlePlantSum',
    GetWholePlantSum: '/bms/wholePlantSum',
    GetTopInformation: '/bms/topInformation'
  },
  power: {
    GetSinglePlantSum: '/power/singlePlantSum',
    GetWholePlantSum: '/power/wholePlantSum',
    GetTopInformation: '/power/topInformation',
    GetAnalysisCharts: '/power/analysisCharts'
  },
  info: {
    GetAllInfo: '/info/all',
    GetAvailability: '/info/availability',
    GetEnergyMapping: '/info/energyMapping' // 案場若有多 types(solar, ess, power) 清單
  }
};

// --------------------------- solar -----------------------------
export var getSolarSinglePlantSumApi = function getSolarSinglePlantSumApi(fId) {
  return axios.post(Api.solar.GetSinglePlantSum, {
    fId: fId
  });
};
export var getSolarWholePlantSumApi = function getSolarWholePlantSumApi() {
  return axios.post(Api.solar.GetWholePlantSum);
};
export var getSolarTopInformationApi = function getSolarTopInformationApi(_ref) {
  var fId = _ref.fId,
    factoryName = _ref.factoryName;
  return axios.post(Api.solar.GetTopInformation, {
    fId: fId,
    factoryName: factoryName
  });
};
export var getSolarAnalysisChartsApi = function getSolarAnalysisChartsApi(fId) {
  return axios.post(Api.solar.GetAnalysisCharts, {
    fId: fId
  });
};

// --------------------------- bms -----------------------------
export var getBmsSinglePlantSumApi = function getBmsSinglePlantSumApi(fId) {
  return axios.post(Api.bms.GetSinglePlantSum, {
    fId: fId
  });
};
export var getBmsWholePlantSumApi = function getBmsWholePlantSumApi() {
  return axios.post(Api.bms.GetWholePlantSum);
};
export var getBmsTopInformationApi = function getBmsTopInformationApi(_ref2) {
  var factoryId = _ref2.factoryId;
  return axios.post(Api.bms.GetTopInformation, {
    factoryId: factoryId
  });
};

// --------------------------- power -----------------------------
export var getPowerSinglePlantSumApi = function getPowerSinglePlantSumApi(fId) {
  return axios.post(Api.power.GetSinglePlantSum, {
    fId: fId
  });
};
export var getPowerWholePlantSumApi = function getPowerWholePlantSumApi() {
  return axios.post(Api.power.GetWholePlantSum);
};
export var getPowerTopInformationApi = function getPowerTopInformationApi(_ref3) {
  var fieldName = _ref3.fieldName;
  return axios.post(Api.power.GetTopInformation, {
    fieldName: fieldName
  });
};
export var getPowerAnalysisChartsApi = function getPowerAnalysisChartsApi(_ref4) {
  var fieldId = _ref4.fieldId,
    fieldName = _ref4.fieldName;
  return axios.post(Api.power.GetAnalysisCharts, {
    fieldId: fieldId,
    fieldName: fieldName
  });
};

// --------------------------- info -----------------------------
/**
 * 取得所有類型案場資訊 solar, ess, power
 */
export var getAllInfoApi = function getAllInfoApi() {
  return axios.post(Api.info.GetAllInfo);
};

/**
 * 所有案場的資料妥善率
 * @param {Array} fIdList - 欲查詢的案場ID陣列
 */
export var getAvailabilityApi = function getAvailabilityApi(fIdList) {
  return axios.post(Api.info.GetAvailability, {
    fIdList: fIdList
  });
};

/**
 * 取得有多類型 (solar, ess, power) 的案場清單
 */
export var getEnergyMappingApi = function getEnergyMappingApi() {
  return axios.post(Api.info.GetEnergyMapping);
};